import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { handleScrollTop } from "shared/helpers/scrollTo";
import { Link } from "react-router";
import {
  findLineItem,
  findSubLineItem,
  findSection,
  getSectionPath,
  getLineItemPath,
  makeSectionPath,
  getUnitPath
} from "shared/selectors/unit";
import { Icon, Header, Button, Grid, Responsive } from "semantic-ui-react";
import { last } from "lodash";
import { withRouter } from "../../helpers/withRouter";
import "./roomBookNavigation.scss";

class RoomBookNavigation extends React.Component {
  static propTypes = {
    i18n: PropTypes.object,
    user: PropTypes.object,
    actions: PropTypes.object,
    pageName: PropTypes.string,
    unitPath: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { root, segments, pageTitle, parent } = this.props;

    if (root) {
      const items = segments.map((segment, idx) => {
        return (
          <Link
            key={idx}
            onClick={handleScrollTop}
            className="breadcrumb"
            to={segment.path}
          >
            {segment.title}
          </Link>
        );
      });

      return (
        <div>
          <Responsive minWidth={768}>
            <Grid data-component="roomBookNavigation" stackable>
              <Grid.Column width={12} verticalAlign="middle">
                <Header size="large">
                  <Header.Content>
                    <Header.Subheader>
                      <Link onClick={handleScrollTop} to={root.path}>
                        {root.title}
                      </Link>
                    </Header.Subheader>
                    {items} {pageTitle}
                  </Header.Content>
                </Header>
              </Grid.Column>
              <Grid.Column width={4} verticalAlign="middle" textAlign="right">
                <Button
                  onClick={this.navigateToParent}
                  content={parent.title}
                  icon="chevron left"
                  basic
                />
              </Grid.Column>
            </Grid>
          </Responsive>
          <Responsive maxWidth={767}>
            <Header
              size="large"
              as={Link}
              to={parent.path}
              onClick={handleScrollTop}
              style={{ display: "block" }}
            >
              <Header.Content>
                <Icon name="chevron left" /> {pageTitle}
              </Header.Content>
            </Header>
          </Responsive>
        </div>
      );
    }
    return null;
  }

  navigateToParent = () => {
    const { parent, router } = this.props;

    router.push(parent.path);
    handleScrollTop();
  };
}

const mapStateToProps = (state, props) => {
  const { sectionId, lineItemId, subLineItemId } = props.params;
  let pageTitle = "asd";
  const segments = [];
  let root = null;
  let section = null;

  if (sectionId) {
    section = findSection(state)(sectionId);

    pageTitle = section.title;
    if (!section.isRoot) {
      const parent = findSection(state)(section.parentId);
      root = {
        path: makeSectionPath(props, parent.id),
        title: parent.title
      };
    } else {
      root = {
        path: getUnitPath(props),
        title: "Ausstattungskatalog"
      };
    }
  }

  if (lineItemId) {
    const lineItem = findLineItem(state)(lineItemId);
    const section = findSection(state)(sectionId);

    pageTitle = lineItem.title;

    segments.push({
      path: getSectionPath(props),
      title: section.title
    });
  }

  if (subLineItemId) {
    const lineItem = findLineItem(state)(lineItemId);
    const subLineItem = findSubLineItem(state)(subLineItemId);

    pageTitle = subLineItem.title;

    if (section.isCompactDisplay) {
      segments.push({
        path: getSectionPath(props),
        title: section.title
      });
    } else {
      segments.push({
        path: getLineItemPath(props),
        title: lineItem.title
      });
    }
  }

  const parent = last(segments) || root;

  return {
    i18n: state.i18n,
    pageTitle,
    segments,
    root,
    parent,
    unitPath: getUnitPath(props)
  };
};

export default withRouter(connect(mapStateToProps)(RoomBookNavigation));
